


















import Vue from 'vue';
import { VBtn } from 'vuetify/lib';
import * as config from '../../../packages/archistar/config';

enum BtnVariant {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
  PrimaryOutlined = 'primary-outlined',
  SecondaryDark = 'secondary-dark'
}

export default Vue.extend({
  components: {
    VBtn
  },
  props: {
    variant: {
      type: String,
      default: 'primary'
    }
  },
  computed: {
    validatedVariant(): any {
      if (this.variant && config.theme[this.variant]) {
        return this.variant;
      } else if (this.variant && [BtnVariant.SecondaryDark as string].includes(this.variant)) {
        return this.variant;
      }
      return 'primary';
    },
    dark(): boolean | string {
      if (this.$attrs['dark']) return this.$attrs['dark'];

      if (this.outlined) {
        return false;
      }

      const hexCode = config.theme[this.color] || this.$attrs['color'];
      if (!hexCode || (hexCode && hexCode.charAt(0) !== '#')) return false;
      const r = parseInt(hexCode.substr(1, 2), 16);
      const g = parseInt(hexCode.substr(3, 2), 16);
      const b = parseInt(hexCode.substr(4, 2), 16);
      const luminance = (r * 299 + g * 587 + b * 114) / 1000;

      return luminance < 125 ? true : false;
    },
    color(): any {
      if (this.$attrs['color']) {
        return this.$attrs['color'];
      } else if (this.variant && config.theme[this.variant]) {
        return this.variant;
      } else if (this.variant && [BtnVariant.SecondaryDark as string].includes(this.variant)) {
        return 'white';
      }
      return 'primary';
    },
    outlined(): boolean | string {
      if (this.$attrs['outlined']) {
        return this.$attrs['outlined'];
      } else if (
        this.variant &&
        [BtnVariant.Secondary as string, BtnVariant.PrimaryOutlined as string].includes(this.variant)
      ) {
        return true;
      }
      return false;
    },
    text(): boolean | string {
      if (this.$attrs['text']) {
        return this.$attrs['text'];
      } else if (this.variant && config.theme[this.variant] && this.variant === BtnVariant.Tertiary) {
        return true;
      }
      return false;
    }
  }
});
